export default {"src":"/_next/static/media/silo.fd72eb81.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};